import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CommonExternalModule } from '../../common/common-external-module';

@Component({
  selector: 'app-confirmation-dialog',
  standalone: true,
  imports: [CommonExternalModule],
  templateUrl: './confirmation-dialog.component.html',
  styleUrl: './confirmation-dialog.component.css'
})
export class ConfirmationDialogComponent  implements OnInit {

  rightBtn: string;
  leftBtn: string;
  showCancel: boolean;

  constructor(
    private dialogRef: MatDialogRef<ConfirmationDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public dialogData: any
  ) {
    dialogRef.disableClose = true;
    if (dialogData.enableOuterClick) {
      this.showCancel = true;
    } else {
      this.showCancel = false;
    }
    this.rightBtn = dialogData.rightBtn;
    this.leftBtn = dialogData.leftBtn;

    if (!this.rightBtn || !this.leftBtn) {
      this.rightBtn = "CONFIRM";
      this.leftBtn = "BACK";
    }
  }
  ngOnInit(): void {
  }
}
